export default {"src":"/_next/static/media/38-icon.7656d37f.svg","height":39,"width":46,"blurWidth":0,"blurHeight":0};